module.exports = __webpack_public_path__ + "img/sc-4-act.5d858736.png";